<span
  class="icon-{{ icon() }}"
  [style.font-size]="size()"
  [attr.aria-hidden]="ariaHidden()"
  [class.support-rtl]="supportRtl()">
</span>
